import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbToolbarComponent } from './toolbar.component';

@NgModule({
  declarations: [MdbToolbarComponent],
  imports: [CommonModule],
  exports: [MdbToolbarComponent],
})
export class MdbToolbarModule {}
